import { storeActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

function cropContent(content: string, maxLength = 25): string {
  if (typeof content !== 'string') return 'Document'
  if (content.length <= maxLength) return content
  return content.slice(0, maxLength) + '...'
}

export function documentCases(
  builder: ActionReducerMapBuilder<NotificationState>,
) {
  builder
    .addCase(
      storeActions.beneficiary.document.create.fulfilled,
      (state, { payload: { document } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated',
          descriptionTransOptions: {
            value:
              'title' in document
                ? document.title
                : cropContent(document.content),
          },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      storeActions.beneficiary.document.delete.fulfilled,
      (
        state,
        {
          meta: {
            arg: { document },
          },
        },
      ) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xDeleted',
          descriptionTransOptions: {
            value:
              'title' in document
                ? document.title
                : cropContent(document.content),
          },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'delete',
            isUndone: false,
            object: document,
            type: 'document',
          },
        })
      },
    )
    .addCase(
      storeActions.beneficiary.document.update.fulfilled,
      (state, { payload: { document } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: {
            value:
              'title' in document
                ? document.title
                : cropContent(document.content),
          },
          icon: 'check',
          id: generateId(),
        })
      },
    )
}
